import {
  IconMapMetroEkb16,
  IconMapMetroKzn16,
  IconMapMetroMsk16,
  IconMapMetroNN16,
  IconMapMetroNovosib16,
  IconMapMetroSam16,
  IconMapMetroSpb16,
  ISVGIconProps,
} from '@cian/ui-kit-design-tokens/icons';

import { UndergroundIconWrapper } from '../../components/UndergroundIconWrapper';
import { useOfferCardContext } from '../../context/offerCardContext';
import { FC, useMemo } from 'react';

const metroIcons = new Map<number, FC<ISVGIconProps>>([
  [2, IconMapMetroSpb16],
  [4743, IconMapMetroEkb16],
  [4777, IconMapMetroKzn16],
  [4897, IconMapMetroNovosib16],
  [4966, IconMapMetroSam16],
  [4885, IconMapMetroNN16],
]);

export function UndergroundIconContainer() {
  const {
    generalInfo: { geo },
  } = useOfferCardContext();

  const iconData = useMemo(() => {
    if (!geo?.underground) {
      return;
    }

    return {
      icon: metroIcons.get(geo.regionId) || IconMapMetroMsk16,
      color: `#${geo.underground.lineColor}`,
    };
  }, [geo]);

  if (!iconData) {
    return null;
  }

  const { icon: Icon, color } = iconData;

  return (
    <UndergroundIconWrapper color={color}>
      <Icon color="current_color" />
    </UndergroundIconWrapper>
  );
}
